import React, { useEffect, useRef, useState } from 'react'
import styled from 'styled-components'
import { ArrowLeft, Sparkles, Package, Share2, FileText, CheckCircle2 } from 'lucide-react'
import { useNavigate } from 'react-router-dom'
import ReactQuill from 'react-quill'
import DOMPurify from 'dompurify'
import 'react-quill/dist/quill.snow.css'
import Errortext from '../../../atoms/Utlis/Errortext'
import { useAppDispatch, useAppSelector } from '../../../../Redux/Hooks'
import { createPackageAPI, updatePackageAPI } from '../../../../Redux/ApiCalls/Dashboard/PackageAPI'
import LoadingDots from '../../../atoms/Utlis/LoadinDots'
import FacebookIconPNG from '../../../../assets/Icons/SocialMedia/facebookIcon.svg'
import InstaIconPNG from '../../../../assets/Icons/SocialMedia/instaIcon.svg'
import WebsiteIconPNG from '../../../../assets/Icons/SocialMedia/websiteIcon.svg'
import YoutubeIconPNG from '../../../../assets/Icons/SocialMedia/youtubeIcon.svg'
import { device } from '../../../atoms/Utlis/media'
import {
  PageContainer,
  Hero,
  HeroGlow,
  HeroRow,
  HeroLeft,
  BackButton,
  HeroText,
  HeroBadge,
  PageTitle,
  PageSubtitle,
  ScrollBody,
  SubmitBar,
  SubmitHint,
  SubmitButton,
} from '../Member/memberFormStyles'

const AddNewPackagePage: React.FC = () => {
  const [packageName, setPackageName] = useState('');
  const [price, setPrice] = useState('');
  const [description, setDescription] = useState('');
  const [pureDescription, setPureDescription] = useState('');
  const [showError, setShowError] = useState(false);
  const [activeButton, setActiveButton] = useState(false);
  const [isShowTextEditor, setIsShowTextEditor] = useState(true);
  const [packageWebsite, setPackageWebsite] = useState('');
  const [packageInsta, setPackageInsta] = useState('');
  const [packageFacebook, setPackageFacebook] = useState('');
  const [packageYoutube, setPackageYoutube] = useState('');
  const [isPackageChange, setIsPackageChange] = useState(false);
  const navigate = useNavigate();
  const quillRef = useRef<ReactQuill>(null);
  const { loading, currentPackage, isPackageUpdate } = useAppSelector(state => state.package);
  const dispatch = useAppDispatch();
  useEffect(() => {
    if (currentPackage) {
      setPackageName(currentPackage.title);
      setPrice(currentPackage.price.toString());
      setDescription(currentPackage.description);
      setIsShowTextEditor(false);
      setPureDescription(DOMPurify.sanitize(currentPackage.description));
      setPackageWebsite(currentPackage.website || '');
      setPackageFacebook(currentPackage.facebook_link || '');
      setPackageInsta(currentPackage.insta_link || '');
      setPackageYoutube(currentPackage.youtube_link || '');
    } else {
      // New package: keep social links empty so only placeholders show
      setPackageWebsite('');
      setPackageFacebook('');
      setPackageInsta('');
      setPackageYoutube('');
    }
  }, [currentPackage])
  useEffect(() => {
    handleActiveButton();
    if (currentPackage)
      handlePackageChange();
  }, [packageName, price, description, packageWebsite, packageFacebook, packageInsta, packageYoutube])

  useEffect(() => {

    if (isPackageUpdate) {
      navigate('/dashboard/packages/all');
    }

  }, [isPackageUpdate])
  const handleSubmit = () => {
    if (!activeButton) {
      setShowError(true);
    } else {
      // // console.log("send package data");

      dispatch(createPackageAPI({ title: packageName, price: parseInt(price), description, website: packageWebsite, facebook_link: packageFacebook, insta_link: packageInsta, youtube_link: packageYoutube }))
    }
  }

  const canSaveChanges = activeButton && isPackageChange

  const handleUpdate = () => {
    console.log(description)
    if (!canSaveChanges) {
      setShowError(true);
    } else {
      // // console.log("send package data");
      if (currentPackage)
        dispatch(updatePackageAPI({ title: packageName, price: parseInt(price), description, package_id: currentPackage.id, website: packageWebsite, facebook_link: packageFacebook, insta_link: packageInsta, youtube_link: packageYoutube }))
    }
  }
  const validatePackageName = (packageName: string) => {
    if (packageName.length > 0 && packageName.length < 40) {
      return true;
    } else
      return false;
  }
  const validatePrice = (price: string) => {
    if (price.length > 0 && price.length < 8) {
      return true;
    } else
      return false;
  }
  const validateDescription = (description: string) => {
    if (description.length > 0 && description !== '<p><br></p>') {
      // console.log(description)
      return true;

    }
    else return false;
  }
  const onchangePackage = (name: string, value: string) => {
    if (name === "name" && (value.length === 0 || validatePackageName(value))) {
      setPackageName(value);
    } else if (name === "price" && (value.length === 0 || validatePrice(value))) {
      setPrice(value);
    } else if (name === "description" && (value.length === 0 || validateDescription(value))) {
      console.log(value);
      setDescription(value);
    } else if (name === "website" && value.length < 45) {
      setPackageWebsite(value);
    } else if (name === "insta" && value.length < 45) {
      setPackageInsta(value);
    } else if (name === "facebook" && value.length < 45) {
      setPackageFacebook(value);
    } else if (name === "youtube" && value.length < 45) {
      setPackageYoutube(value);
    }
  }
  const isWebsiteChange = () => {
    if (currentPackage && currentPackage.website) {
      if (currentPackage.website !== packageWebsite) return true;
      else return false;
    } else {
      if (packageWebsite && packageWebsite.length > 0) return true;
      else return false;
    }
  }
  const isInstaChange = () => {
    if (currentPackage && currentPackage.insta_link) {
      if (currentPackage.insta_link !== packageInsta) return true;
      else return false;
    } else {
      if (packageInsta && packageInsta.length > 0) return true;
      else return false;
    }
  }
  const isFaceBookChange = () => {
    if (currentPackage && currentPackage.facebook_link) {
      if (currentPackage.facebook_link !== packageFacebook) return true;
      else return false;
    } else {
      if (packageFacebook && packageFacebook.length > 0) return true;
      else return false;
    }
  }
  const isYoutubeChange = () => {
    if (currentPackage && currentPackage.youtube_link) {
      if (currentPackage.youtube_link !== packageYoutube) return true;
      else return false;
    } else {
      if (packageYoutube && packageYoutube.length > 0) return true;
      else return false;
    }
  }
  const handlePackageChange = () => {

    if (currentPackage) {

      if (packageName !== currentPackage.title || parseInt(price) !== currentPackage.price || description !== currentPackage.description || isWebsiteChange() || isYoutubeChange() || isInstaChange() || isFaceBookChange()) {
        // console.log("++++++++++++")
        // console.log(isWebsiteChange())
        // console.log("++++++++++++")
        setIsPackageChange(true);
      } else {
        setIsPackageChange(false);

      }
    }
  }
  const handleActiveButton = () => {
    if (packageName.length > 0 && packageName.length < 40 && price.length > 0 && price.length < 8 && description.length > 0 && isValidSocialData("insta") && isValidSocialData("website") && isValidSocialData("facebook") && isValidSocialData("youtube")) {
      setActiveButton(true);
    } else {
      setActiveButton(false);
    }
  }
  function isValidURL(url: string) {
    const pattern = new RegExp(
      '^(https?:\\/\\/)?' + // protocol
      "((([a-zA-Z0-9$_.+!*',;?&=-]|%[0-9a-fA-F]{2})+:)*([a-zA-Z0-9$_.+!*',;?&=-]|%[0-9a-fA-F]{2})+@)?" + // username:password@
      '((\\[(|((25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\\.){3}(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?))\\])|' + // IP address
      "(([a-zA-Z0-9$_.+!*',;?&=-]|%[0-9a-fA-F]{2})+\\.)*[a-zA-Z0-9](([a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?\\.)+" + // subdomain
      '[a-zA-Z0-9-]{2,63}\\.?)' + // domain name
      '(:\\d{1,5})?' + // port
      "(\\/([a-zA-Z0-9$_.+!*',;:@&=-]|%[0-9a-fA-F]{2})*)*" + // path
      "(\\?[a-zA-Z0-9$_.+!*',;:@&=-]*(\\([a-zA-Z0-9$_.+!*',;:@&=-]|%[0-9a-fA-F]{2})*\\))*" + // query string
      "(#([a-zA-Z0-9$_.+!*',;:@&=-]|%[0-9a-fA-F]{2})*)?$",
      'i',
    ) // fragment locator

    return pattern.test(url)
  }
  const isValidSocialData = (name: string) => {
    if (name === "website" && packageWebsite) {
      if (packageWebsite && packageWebsite.length > 0 && isValidURL(packageWebsite)) return true
      else return false

    } else if (name === "insta" && packageInsta) {
      if (packageInsta && packageInsta.length > 0 && isValidURL(packageInsta)) return true
      else return false

    } else if (name === "facebook" && packageFacebook) {
      if (packageFacebook && packageFacebook.length > 0 && isValidURL(packageFacebook)) return true
      else return false

    } else if (name === "youtube" && packageYoutube) {
      if (packageYoutube && packageYoutube.length > 0 && isValidURL(packageYoutube)) return true
      else return false

    } else return true;
  }

  const submitHint = activeButton
    ? 'Looking great! Hit submit to publish this package.'
    : 'Fill in name, price, and description to create your package.'

  return (
    <PageContainer>
      <Hero>
        <HeroGlow />
        <HeroRow>
          <HeroLeft>
            <BackButton type="button" onClick={() => navigate(-1)} aria-label="Go back">
              <ArrowLeft size={18} />
            </BackButton>
            <HeroText>
              <div className="flex flex-col">
                <HeroBadge>
                  <Sparkles size={12} />
                  Studio packages
                </HeroBadge>
                <PageTitle className="linear-text">
                  {currentPackage ? 'Edit Package' : 'Add Package'}
                </PageTitle>
                <PageSubtitle>
                  {currentPackage
                    ? 'Update pricing, description, and social links for this package.'
                    : 'Create a package with pricing, description, and social links to share with clients.'}
                </PageSubtitle>
              </div>
            </HeroText>
          </HeroLeft>
          {currentPackage && (
            <HeroActions>
              {loading ? (
                <LoadingDots />
              ) : (
                <HeroSaveBtn
                  type="button"
                  $ready={canSaveChanges}
                  onClick={handleUpdate}
                >
                  {canSaveChanges && <CheckCircle2 size={16} />}
                  Save changes
                </HeroSaveBtn>
              )}
            </HeroActions>
          )}
        </HeroRow>
      </Hero>

      <ScrollBody>
        <FormGrid>
          <FormCard>
            <CardHeader>
              <CardIcon>
                <Package size={18} />
              </CardIcon>
              <div>
                <CardTitle>Package details</CardTitle>
                <CardSubtitle>Name and pricing for this offering</CardSubtitle>
              </div>
            </CardHeader>
            <FieldsRow>
              <Field>
                <Label>Package name</Label>
                <Input
                  placeholder="e.g. Wedding Premium"
                  value={packageName}
                  type="text"
                  onChange={(e) => onchangePackage('name', e.target.value)}
                />
                <Errortext
                  show={showError && !validatePackageName(packageName)}
                  message="Please provide valid package name."
                />
              </Field>
              <Field>
                <Label>Package price</Label>
                <Input
                  placeholder="Amount"
                  type="number"
                  value={price}
                  onChange={(e) => onchangePackage('price', e.target.value)}
                />
                <Errortext
                  show={showError && !validatePrice(price)}
                  message="Please provide valid price"
                />
              </Field>
            </FieldsRow>
          </FormCard>

          <TwoCol>
            <FormCard>
              <CardHeader>
                <CardIcon>
                  <FileText size={18} />
                </CardIcon>
                <div>
                  <CardTitle>Description</CardTitle>
                  <CardSubtitle>What clients get with this package</CardSubtitle>
                </div>
              </CardHeader>
              <DescriptionTab>
                {isShowTextEditor ? (
                  <StyledDescriptionContainer
                    value={description}
                    ref={quillRef}
                    theme="snow"
                    onChange={(e) => onchangePackage('description', e)}
                    modules={{
                      toolbar: [
                        [{ header: [1, 2, 3, 4, 5, 6] }, { font: [] }],
                        [{ size: ['small', false, 'large', 'huge'] }],
                        ['bold', 'italic', 'underline', 'strike', 'blockquote'],
                        [
                          { list: 'ordered' },
                          { list: 'bullet' },
                          { indent: -1 },
                          { indent: +1 },
                        ],
                        ['link'],
                      ],
                    }}
                  />
                ) : (
                  <DescriptionContainer onClick={() => setIsShowTextEditor(true)}>
                    <div dangerouslySetInnerHTML={{ __html: description }} />
                  </DescriptionContainer>
                )}
              </DescriptionTab>
              <Errortext
                show={showError && !validateDescription(description)}
                message="Please provide valid description"
              />
            </FormCard>

            <FormCard>
              <CardHeader>
                <CardIcon>
                  <Share2 size={18} />
                </CardIcon>
                <div>
                  <CardTitle>Social links</CardTitle>
                  <CardSubtitle>Optional profile & website URLs</CardSubtitle>
                </div>
              </CardHeader>
              <SocialStack>
                <Field>
                  <Label>Website</Label>
                  <SocialInputWrap>
                    <SocialIcon src={WebsiteIconPNG} alt="" />
                    <SocialInput
                      value={packageWebsite}
                      type="text"
                      placeholder="Enter your website Link"
                      onChange={(e) => onchangePackage('website', e.target.value)}
                    />
                  </SocialInputWrap>
                  <Errortext
                    show={showError && !isValidSocialData('website')}
                    message="Please provide valid website link."
                  />
                </Field>
                <Field>
                  <Label>Instagram</Label>
                  <SocialInputWrap>
                    <SocialIcon src={InstaIconPNG} alt="" />
                    <SocialInput
                      value={packageInsta}
                      type="text"
                      placeholder="Enter your Instagram Link"
                      onChange={(e) => onchangePackage('insta', e.target.value)}
                    />
                  </SocialInputWrap>
                  <Errortext
                    show={showError && !isValidSocialData('insta')}
                    message="Please provide valid instagram link."
                  />
                </Field>
                <Field>
                  <Label>Facebook</Label>
                  <SocialInputWrap>
                    <SocialIcon src={FacebookIconPNG} alt="" />
                    <SocialInput
                      value={packageFacebook}
                      type="text"
                      placeholder="Enter your Facebook Link"
                      onChange={(e) => onchangePackage('facebook', e.target.value)}
                    />
                  </SocialInputWrap>
                  <Errortext
                    show={showError && !isValidSocialData('facebook')}
                    message="Please provide valid facebook link."
                  />
                </Field>
                <Field>
                  <Label>Youtube</Label>
                  <SocialInputWrap>
                    <SocialIcon src={YoutubeIconPNG} alt="" />
                    <SocialInput
                      value={packageYoutube}
                      type="text"
                      placeholder="Enter your Youtube Link"
                      onChange={(e) => onchangePackage('youtube', e.target.value)}
                    />
                  </SocialInputWrap>
                  <Errortext
                    show={showError && !isValidSocialData('youtube')}
                    message="Please provide valid youtube link."
                  />
                </Field>
              </SocialStack>
            </FormCard>
          </TwoCol>
        </FormGrid>

        {!currentPackage && (
          <SubmitBar>
            <SubmitHint>{submitHint}</SubmitHint>
            {loading ? (
              <LoadingDots />
            ) : (
              <SubmitButton type="button" $ready={activeButton} onClick={handleSubmit}>
                {activeButton && <CheckCircle2 size={18} />}
                Create package
              </SubmitButton>
            )}
          </SubmitBar>
        )}
      </ScrollBody>
    </PageContainer>
  )
}

export default AddNewPackagePage

const HeroActions = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  flex-wrap: wrap;
  flex-shrink: 0;
`

const HeroSaveBtn = styled(SubmitButton)`
  min-width: unset;
  height: 40px;
  padding: 0 18px;
  font-size: 14px;
`

const FormGrid = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`

const FormCard = styled.div`
  background: #fff;
  border-radius: 18px;
  border: 1px solid rgba(23, 23, 23, 0.06);
  box-shadow: 0 4px 18px rgba(0, 0, 0, 0.04);
  padding: 22px;
  display: flex;
  flex-direction: column;
  gap: 16px;
`

const CardHeader = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
`

const CardIcon = styled.div`
  width: 40px;
  height: 40px;
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #c94daa;
  background: rgba(201, 77, 170, 0.1);
  flex-shrink: 0;
`

const CardTitle = styled.h3`
  margin: 0;
  font-family: Urbanist, sans-serif;
  font-size: 16px;
  font-weight: 800;
  color: #171717;
`

const CardSubtitle = styled.p`
  margin: 2px 0 0;
  font-family: Montserrat, sans-serif;
  font-size: 12px;
  font-weight: 500;
  color: rgba(23, 23, 23, 0.5);
`

const FieldsRow = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 16px;
  @media ${device.tablet} { grid-template-columns: 1fr; }
`

const TwoCol = styled.div`
  display: grid;
  grid-template-columns: 1.4fr 1fr;
  gap: 16px;
  align-items: start;
  @media ${device.laptop} { grid-template-columns: 1fr; }
`

const Field = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`

const Label = styled.label`
  font-family: Montserrat, sans-serif;
  font-size: 11px;
  font-weight: 700;
  color: rgba(23, 23, 23, 0.5);
  text-transform: uppercase;
  letter-spacing: 0.05em;
`

const Input = styled.input`
  width: 100%;
  box-sizing: border-box;
  height: 44px;
  padding: 0 14px;
  background: #fafafa;
  border: 1px solid rgba(23, 23, 23, 0.1);
  border-radius: 12px;
  font-family: Urbanist, sans-serif;
  font-size: 14px;
  font-weight: 600;
  color: #171717;
  transition: border-color 0.15s ease, box-shadow 0.15s ease;

  &::-webkit-outer-spin-button,
  &::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }

  &:focus {
    outline: none;
    border-color: rgba(201, 77, 170, 0.4);
    box-shadow: 0 0 0 3px rgba(201, 77, 170, 0.1);
    background: #fff;
  }

  &::placeholder {
    color: rgba(23, 23, 23, 0.35);
    font-weight: 500;
  }
`

const SocialStack = styled.div`
  display: flex;
  flex-direction: column;
  gap: 14px;
`

const SocialInputWrap = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  height: 44px;
  padding: 0 12px;
  border-radius: 12px;
  background: #fafafa;
  border: 1px solid rgba(23, 23, 23, 0.1);
  transition: border-color 0.15s ease, box-shadow 0.15s ease;

  &:focus-within {
    border-color: rgba(201, 77, 170, 0.4);
    box-shadow: 0 0 0 3px rgba(201, 77, 170, 0.1);
    background: #fff;
  }
`

const SocialInput = styled.input`
  flex: 1;
  min-width: 0;
  border: none;
  background: transparent;
  font-family: Urbanist, sans-serif;
  font-size: 14px;
  font-weight: 600;
  color: #171717;
  &:focus { outline: none; }
  &::placeholder {
    color: rgba(23, 23, 23, 0.35);
    font-weight: 500;
  }
`

const SocialIcon = styled.img`
  height: 18px;
  width: 18px;
  flex-shrink: 0;
`

const DescriptionTab = styled.div`
  background: #fff;
  border: 1px solid rgba(23, 23, 23, 0.08);
  border-radius: 14px;
  overflow: hidden;
`

const StyledDescriptionContainer = styled(ReactQuill)`
  .ql-toolbar {
    border: none;
    border-bottom: 1px solid rgba(23, 23, 23, 0.08);
    background-color: #fafafa;
  }

  .ql-container {
    background-color: white;
    height: 260px;
    border: none !important;
    font-family: Montserrat, sans-serif;
  }

  .ql-editor {
    padding: 16px 18px;
  }
`

const DescriptionContainer = styled.div`
  background-color: white;
  width: 100%;
  min-height: 260px;
  max-height: 360px;
  padding: 16px 18px;
  overflow: auto;
  cursor: text;
  box-sizing: border-box;
`